module.exports = __webpack_public_path__ + "src/assets/img/user_role_ana.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user_role_ana.svg
// module id = ppUl
// module chunks = 80